import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NFSeEdicao } from '@/features/nfse/page/edicao/NFSeEdicao';

const RouteNFSeParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar', 'visualizar']),
        idpk: z.string(),
    }),
]);

export type RouteNFSeParams = z.infer<typeof RouteNFSeParamsSchema>;

export const Route = createFileRoute('/a/nfse/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteNFSeParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <NFSeEdicao {...params} />;
}
